class CollectionHero extends window.BAO.CustomElement() {
  constructor () {
    super()
    this.initialize()
  }

  initialize () {
    this.checkHeight()
  }

  setupListeners () {
    super.setupListeners()

    this.handleClick = this.handleClick.bind(this)

    if (this?.els?.showMore?.exists) {
      this.listeners.add(this.els.showMore.element, 'click', this.handleClick)
    }
    if (this?.els?.showLess?.exists) {
      this.listeners.add(this.els.showLess.element, 'click', this.handleClick)
    }

    if (this?.els?.openQuiz?.exists) {
      this.listeners.add(this.els.openQuiz.element, 'click', () => {
        const quizEl = this.els.quiz.element
        this.classList.add('clc-Hero-quizActive')
        quizEl.classList.add('clc-Hero_Quiz-active')
        const quizInnerEl = quizEl.querySelector('.clc-Quiz')
        const height =
          parseInt(getComputedStyle(quizInnerEl).marginTop) +
          quizInnerEl.offsetHeight
        this.els.heroInner.element.style.minHeight = `${height + 60}px`
      })
    }
    if (this?.els?.closeQuiz?.exists) {
      this.listeners.add(this.els.closeQuiz.element, 'click', () => {
        const quizEl = this.els.quiz.element
        quizEl
          .querySelectorAll('.clc-Quiz_Answer-refined .clc-Quiz_Button')
          .forEach(button => button.click())
        this.classList.remove('clc-Hero-quizActive')
        quizEl.classList.remove('clc-Hero_Quiz-active')
        this.els.heroInner.element.style.minHeight = 'unset'
      })
    }
  }

  handleClick (event) {
    if (event.target.closest(this.els.showMore.selector)) {
      this.showMore()
    }
    if (event.target.closest(this.els.showLess.selector)) {
      this.showLess()
    }
  }

  checkHeight () {
    const heightOfTwoLines = 68

    if (
      this.els?.showMore?.exists &&
      this.descriptionEl?.clientHeight > heightOfTwoLines
    ) {
      this.showMoreEl.setAttribute(this.hiddenAttribute, false)
    }
  }

  showMore () {
    this.descriptionContentEl.classList.toggle(
      'clc-Hero_DescriptionContent-short',
    )

    this.showMoreEl.setAttribute(this.hiddenAttribute, true)
    this.showLessEl.setAttribute(this.hiddenAttribute, false)
  }

  showLess () {
    this.descriptionContentEl.classList.toggle(
      'clc-Hero_DescriptionContent-short',
    )

    this.showMoreEl.setAttribute(this.hiddenAttribute, false)
    this.showLessEl.setAttribute(this.hiddenAttribute, true)
  }

  get hiddenAttribute () {
    return `aria-hidden`
  }

  get descriptionContentEl () {
    return this?.els?.descriptionContent?.element
  }

  get descriptionEl () {
    return this?.els?.description?.element
  }

  get showMoreEl () {
    return this?.els?.showMore?.element
  }

  get showLessEl () {
    return this?.els?.showLess?.element
  }
}

if (!customElements.get('collection-hero')) {
  customElements.define('collection-hero', CollectionHero)
}
